import e from "@dialpad/dialtone-tokens/layered/themes/tokens-blue-hour-colors.css?inline";
//#region themes/blue-hour.js
var t = {
	brand: {
		css: e,
		name: "blue-hour"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
